import type { UpdateSession } from "next-auth/react";

export const AUTHORITATIVE_SESSION_REFRESH_PAYLOAD = {
  refresh: "authoritative-user",
} as const;

export function refreshSessionFromDatabase(update: UpdateSession) {
  // Auth.js only sets JWT trigger="update" when update receives a payload.
  return update(AUTHORITATIVE_SESSION_REFRESH_PAYLOAD);
}
